import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import PropTypes from 'prop-types';
import ImageElement from '../../../../components/ImageElement/ImageElement';

export default function InformationCollum() {
  const { usersData } = useSelector((state) => state.user);

  return (
    <Styled.ProfileContainer>
      <ImageElement image={usersData?.IMAGEM_PERFIL} />
    </Styled.ProfileContainer>
  );
}

InformationCollum.propTypes = {
  control: PropTypes.any,
  isEditing: PropTypes.bool,
};
